<template>
  <div class="PaymentRecord">
    <!-- 头部新增按钮 -->
    <el-row>
      <el-form :inline="true" class="demo-form-inline toolbar" style="padding-bottom: 0px" @submit.native.prevent>
        <el-form-item>
          <el-button type="warning" style="margin-left: 30px" icon="el-icon-plus" @click="addButton">新增</el-button>
        </el-form-item>
      </el-form>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-table :data="tableData" :header-cell-style="{ background: '#a7cfff', color: '#606266' }" style="width: 100%">
        <el-table-column prop="planName" label="方案名称" align="center"></el-table-column>

        <el-table-column prop="planTime" label="排班时间" align="center"></el-table-column>

        <el-table-column prop="isHandover" label="是否交接" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isHandover == 1">是</span>
            <span v-if="scope.row.isHandover == 0">否</span>
          </template>
        </el-table-column>

        <el-table-column prop="option" label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="redactButton(scope.row)">编辑</el-button>
            <el-button type="danger" size="mini" @click="deleteButton(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <!-- 弹出新增dialog -->
    <el-dialog width="560px" title="新增方案" :visible.sync="dialogaddVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" @close="confirmCancel">
      <el-form ref="addAdmissionRef" :model="addForm" :rules="rules">
        <el-form-item label="方案名称" :label-width="formLabelWidth" prop="planName">
          <el-input style="width: 220px" v-model.trim="addForm.planName" placeholder="请输入方案" clearable></el-input>
        </el-form-item>
        <el-form-item label="排班时间" :label-width="formLabelWidth" prop="planTime">
          <el-date-picker v-model="addForm.planTime" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否交接" :label-width="formLabelWidth" prop="isHandover" class="one">
          <el-radio-group v-model="addForm.isHandover" @change="handoverChange">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click="dialogaddVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAdd">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 弹出编辑dialog -->
    <el-dialog width="560px" title="编辑方案" :visible.sync="dialogVisible" :close-on-click-modal="false"
      @close="closeAddDialog">
      <el-form ref="redactRef" :model="form" :rules="rules">
        <el-form-item label="方案名称" :label-width="formLabelWidth" prop="planName">
          <el-input style="width: 220px" v-model.trim="form.planName" placeholder="请输入方案" clearable></el-input>
        </el-form-item>
        <el-form-item label="排班时间" :label-width="formLabelWidth" prop="planTime">
          <el-date-picker v-model="form.planTime" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="是否交接" :label-width="formLabelWidth" prop="isHandover" class="one">
          <el-radio-group v-model="form.isHandover" @change="handoverChange">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmButton">确 定</el-button>
      </div>
    </el-dialog>

    <el-pagination class="fenye" background layout="total,prev, pager, next" :total="total" :current-page.sync="pageNum"
      @current-change="changePage" align="center"></el-pagination>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [], //排班方案列表数据
      //分页
      total: 0,
      pageNum: 1,
      pageSize: 10, //分页总数
      //弹出新增内容
      addForm: {
        planName: "",
        planTime: "",
        isHandover: "",
      },
      //弹出编辑内容
      form: {
        planName: "",
        planTime: "",
        isHandover: "",
      },
      //新增默认弹窗为关闭
      dialogaddVisible: false,
      //编辑默认弹窗为关闭
      dialogVisible: false,
      formLabelWidth: "120px",
      //校验规则
      rules: {
        //处理方案名称的正则验证
        planName: [
          {
            required: true, //是否必填
            message: "方案名称不能为空", //规则
            trigger: "blur", //何事件触发
          },
        ],
        //处理排班时间的正则验证
        planTime: [
          {
            required: true, //是否必填
            message: "请输入时间", //规则
            trigger: "blur", //何事件触发
          },
        ],
        //处理是否交接的正则验证
        isHandover: [
          {
            required: true, //是否必填
            message: "请选择是否交接", //规则
            trigger: "blur", //何事件触发
          },
        ],
      },
    };
  },
  methods: {
    handoverChange(val) {
      console.log(val);
      console.log(this.addForm.isHandover);
    },
    //查询排班列表
    queryPayList() {
      let param = {
        id: this.id,
        planName: this.planName,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      };
      this.$postJson("omc/plan/queryPlanNew", param).then((res) => {
        this.tableData = res.result.list; //列表数据
        this.total = Number(res.result.total); //页码total
      });
    },
    //点击新增按钮打开表单
    addButton() {
      this.dialogaddVisible = true; //打开弹窗
    },
    //点击确定新增表单
    confirmAdd() {
      this.$refs.addAdmissionRef.validate((valid) => {
        // console.log(valid); //判断会出现fales和true
        if (valid) {
          let params = Object.assign({}, this.addForm);
          params.planTime = params.planTime[0] + "-" + params.planTime[1]; //拼接时间格式
          this.$postJson("omc/plan/insertNewPlan", params).then((res) => {
            // console.log(res, 777);
            if (res.code == 200) {
              this.dialogaddVisible = false; //关闭弹窗
              this.queryPayList(); //刷新数据列表
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
          });
        }
      });
    },
    //新增点取消重置表单
    // confirmCancel() {
    //   this.$refs.addAdmissionRef.resetFields(); //重置表单
    //   this.dialogaddVisible = false; //关闭弹窗
    // },
    //点击编辑按钮打开表单返显数据
    redactButton(row) {
      console.log(row);
      console.log(row.planTime.split("-"));
      let planTime = row.planTime.split("-");
      let statTime = `${planTime[0]}-${planTime[1]}-${planTime[2]}`;
      let lastTime = `${planTime[3]}-${planTime[4]}-${planTime[5]}`;
      let timeArr = [statTime, lastTime];
      this.form = Object.assign({}, row);
      this.form.planTime = timeArr;
      this.dialogVisible = true; //打开弹窗
    },
    //编辑点击确定
    confirmButton() {
      this.$refs.redactRef.validate((valid) => {
        console.log(valid); //判断会出现fales和true
        if (valid) {
          // let params = Object.assign({}, this.form);
          let params = {
            id: this.form.id,
            planName: this.form.planName,
            planTime: this.form.planTime[0] + "-" + this.form.planTime[1],
            isHandover: this.form.isHandover,
          };
          console.log(this.form, "this.form");
          console.log(params, "params");
          // (params.planName = params.planName),
          //   (params.planTime = params.planTime[0] + "-" + params.planTime[1]); //拼接时间格式
          // params.isHandover = params.isHandover == "是" ? 1 : 0; //处理是否交接
          this.$postJson("omc/plan/updateNewPlan", params).then((res) => {
            console.log(res, 7788);
            if (res.code == 200) {
              this.queryPayList(); //刷新数据列表
              this.dialogVisible = false; //关闭弹窗
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
          });
        }
      });
      // this.dialogVisible = false; //关闭弹窗
    },
    //编辑点取消清空表单
    closeAddDialog() {
      this.$refs["redactRef"].resetFields();
    },
    //删除按钮
    deleteButton(id) {
      console.log(id);
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$postJson("omc/plan/deleteNewPlan", { id: id }).then((res) => {
            if (res.code == 200) {
              this.queryPayList(); //刷新数据列表
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //关闭处理新增dialog的回调
    confirmCancel() {
      this.$refs.addAdmissionRef.resetFields(); //移除校验结果并重置字段值
    },

    changePage(val) {
      this.pageNum = val;
      this.queryPayList();
    },
  },
  //自动刷新
  mounted() {
    this.queryPayList(); //刷新缴费记录单列表的数据
  },
};
</script>
<style lang="scss">
.curcor {
  font-size: 28px;
  color: rgb(1, 185, 237);
  cursor: pointer;
}

.one .el-form-item__content {
  height: 40px;
  line-height: 40px;
}
</style>
